var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCursive({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 8,
    height: 12,
    viewBox: "0 0 8 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.98956 10.2656L5.72093 2.14424C5.8593 1.47487 5.99768 1.34549 7.2363 1.23637L7.36006 0.651367H3.11205L2.9883 1.23637C4.1808 1.34437 4.2573 1.47487 4.11893 2.14424L2.39093 10.2656C2.25256 10.935 2.11418 11.0644 0.87668 11.1724L0.75293 11.7574H4.99868L5.12243 11.1724C3.92993 11.0655 3.8523 10.935 3.99068 10.2656H3.98956Z",
    fill: "#6B7280"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCursive);
export default __webpack_public_path__ + "static/media/Cursive.4566992b70c5d9071817ed76530ddd34.svg";
export { ForwardRef as ReactComponent };